import { account } from '../../../store.config'

const maintenanceLinks = [
  '/cartao/cartonista/',
  '/cartao/beneficios-cartao/',
  '/aceitar-termos-promocao/',
]

const verifyMaintenance = (link: string) => {
  if (
    account !== 'avenidab2c' &&
    account !== 'superpao' &&
    account !== 'compremais'
  ) {
    return true
  }
  return maintenanceLinks.includes(link)
}

export { verifyMaintenance }
